define('companiesDetailBodyInfoView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'template!companiesDetailBodyInfoView'
], function (
  App,
  Module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'companies-detail-info-view',

    ui: {
      webSite: '.js-webSite',
      industry: '.js-industry',
      linkedIn: '.js-linkedIn',
      companyPhone: '.js-companyPhone',
      foundedYear: '.js-foundedYear',
      employees: '.js-employees',
      annualRevenue: '.js-annualRevenue',
      totalFunding: '.js-totalFunding',
      save: '.js-save'
    },

    events: {
      'click @ui.save': 'onSave'
    },

    // Re-render when the model changes (e.g. after a successful save the server
    // echoes back the persisted company).
    modelEvents: {
      'sync': 'render'
    },

    // Trim a text input, returning null when empty so we don't store empty strings.
    textVal: function ($input) {
      var value = ($input.val() || '').trim();
      return value === '' ? null : value;
    },

    // Parse a numeric input, returning null when empty/invalid.
    numberVal: function ($input) {
      var raw = ($input.val() || '').trim();
      if (raw === '') {
        return null;
      }
      var value = Number(raw);
      return isNaN(value) ? null : value;
    },

    onSave: function () {
      var attrs = {
        // The name is required by the backend update endpoint; keep the current one.
        name: this.model.get('name'),
        webSite: this.textVal(this.ui.webSite),
        industry: this.textVal(this.ui.industry),
        linkedIn: this.textVal(this.ui.linkedIn),
        companyPhone: this.textVal(this.ui.companyPhone),
        foundedYear: this.numberVal(this.ui.foundedYear),
        employees: this.numberVal(this.ui.employees),
        annualRevenue: this.numberVal(this.ui.annualRevenue),
        totalFunding: this.numberVal(this.ui.totalFunding)
      };

      this.ui.save.prop('disabled', true);
      this.model.save(attrs, { wait: true })
        .done(_.bind(function () {
          App.trigger('notification:success', _.i18n('common.changesSaved', null, 'Changes saved'));
        }, this))
        .fail(_.bind(function () {
          App.trigger('notification:error', _.i18n('common.error', null, 'An error occurred'));
        }, this))
        .always(_.bind(function () {
          if (!this.isDestroyed) {
            this.ui.save.prop('disabled', false);
          }
        }, this));
    }
  });
});

